import { render, staticRenderFns } from "./ObjectDetailsHeader.vue?vue&type=template&id=729239fb&"
import script from "./ObjectDetailsHeader.vue?vue&type=script&lang=js&"
export * from "./ObjectDetailsHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports